export default __webpack_public_path__ + "static/media/Card.479d8433.png";